module.exports = __webpack_public_path__ + "static/media/banner_7.add0c5bc.jpg";